import { render, staticRenderFns } from "./ReceptionUserFixedPhraseSelector.vue?vue&type=template&id=9d1bdf4a&scoped=true&"
import script from "./ReceptionUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./ReceptionUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionUserFixedPhraseSelector.vue?vue&type=style&index=0&id=9d1bdf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1bdf4a",
  null
  
)

export default component.exports